import {reducerWithInitialState} from "typescript-fsa-reducers";
import { loginActions } from "../actions/LoginAction";
import { deepCopyTableThingyState, LoginInitialState } from "../typing/loginstate";



export default reducerWithInitialState(LoginInitialState)
        .case(loginActions.doLogin, (state,payload) => {

            console.log(payload, state);
            
            const deepCopy=deepCopyTableThingyState(state);
            deepCopy.model.Name = payload.Token.Name;
            deepCopy.model.role = payload.Token.role;
            deepCopy.model.username = payload.Token.username;
            deepCopy.model.id = payload.Token.id;
            deepCopy.model.token = payload.Token.token;
            // Herkunft des Passworts. Bei 1 (Auslieferung) sperrt die API
            // alles ausser dem Wechsel - die Oberflaeche muss das wissen,
            // sonst zeigt sie eine Seite, die nur 403 liefert.
            deepCopy.model.pw_status = payload.Token.pw_status ?? 0;
            deepCopy.view.loginStatus = payload.Token.token !== "";
            return deepCopy;
        })
        .case(loginActions.revokeLogin, (state,payload) => {
            // state.view.loginStatus = true;
            const deepCopy=deepCopyTableThingyState(state);
            deepCopy.model.username = "";
            deepCopy.view.password = "";
            deepCopy.model.token = "";
            deepCopy.model.Name = "";
            deepCopy.model.role = 0;
            deepCopy.model.username = "Nobody";
            deepCopy.model.id = "";
            deepCopy.view.loginStatus = false;
            return deepCopy;
        })
        .case(loginActions.renewToken,(state, payload) => {
            // Only while logged in: a renewal answered after a logout must
            // not bring a token back (anima_core#24).
            if (!state.view.loginStatus || payload.token === "")
            {
                return state;
            }
            const deepCopy=deepCopyTableThingyState(state);
            deepCopy.model.token = payload.token;
            return deepCopy;
        })
        .case(loginActions.setUserAndPassword,(state, payload) => {
            const deepCopy=deepCopyTableThingyState(state);
            deepCopy.model.username = payload.user;
            deepCopy.view.password = payload.pw;
            return deepCopy;
        })
        .case(loginActions.setValueChange, (state,payload) => {
            // state.view.loginStatus = true;
            const deepCopy=deepCopyTableThingyState(state);
            if (payload.parameter === "username")
                deepCopy.model.username=payload.data;
            if (payload.parameter === "password")
                deepCopy.view.password=payload.data;  
            if (payload.parameter === "token")
                deepCopy.model.resettoken=payload.data;           
            return deepCopy;
        })
        ;

        /// Props call immer [ber dispatch und diesen effekt